import api from '@/modules/api.service';
import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';
import { mapRelatorioComReprovacao } from './relatorios-atividades.mappers';

export async function enviarDiretoCorregedoriaDefensorUseCase(
  relatorioId: number,
): Promise<RelatorioAtividadeDto> {
  const response = await api.post(`/relatorios/atividades/${relatorioId}/corregedoria/enviar-defensor`);
  return mapRelatorioComReprovacao(response.data);
}
